// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperContainer-cls1_GyJ","cls2":"PaperContainer-cls2_uvd PaperContainer-cls1_GyJ"};